import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

const Home = () => {
  return (
    <div id="home" className="jumbotron-custom">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <h1 className="display-4">ORM Trust</h1>
            <p className="lead">Out Reach Millions - Enriching Lives</p>
            <hr className="my-4" />
            <p>We are a non-profit organization dedicated to making a difference through various social initiatives.</p>
            <Button variant="primary" href="#donate" className="btn-primary-custom">Donate Now</Button>
          </Col>
          <Col md={6}>
            <img src="/images/orm_banner.jpeg" alt="ORM Trust Banner" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Home;